import SwitchBox from "./switchbox";

export default SwitchBox;
